import handleMethod from '../Utils/APIutils/handleMethod';

class ProfileAPI {
  async getProfile() {
    if (process.env.REACT_APP_CUSTOM_AUTH === 'NONE') {
      return {
        error: false,
        value: {
          employeeInfo: {
            name: 'Dev User',
            jobTitle: 'Developer',
            photo: null
          }
        }
      };
    }

    const Input = {
      type: 'GET',
      method: `api/User/GetMe`,
      params: {}
    };

    const response = await handleMethod(Input);

    return response;
  }

  async getOptions() {
    if (process.env.REACT_APP_CUSTOM_AUTH === 'NONE') {
      return {
        error: false,
        value: {
          rolesList: [],
          statusList: []
        }
      };
    }

    const Input = {
      type: 'GET',
      method: `getOptions`,
      params: {}
    };

    const response = await handleMethod(Input);

    return response;
  }

  async list(page = 1, itemsPerPage = 100) {
    return handleMethod({ type: 'GET', method: `api/Profile?page=${page}&itemsPerPage=${itemsPerPage}` });
  }
}

export const profileAPI = new ProfileAPI();
